import { useContext } from 'react';
import { TranslationsContext } from '@secretescapes/cauldron';

export const useTranslations = () => {
  const translationsState = useContext(TranslationsContext);

  if (!translationsState) {
    throw new Error('Translations state context not initialized!');
  }

  return translationsState;
};
